import { render } from "./chartGantt.vue?vue&type=template&id=b36ef956&scoped=true"
import script from "./chartGantt.vue?vue&type=script&lang=js"
export * from "./chartGantt.vue?vue&type=script&lang=js"

import "./chartGantt.vue?vue&type=style&index=0&id=b36ef956&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36ef956"]])

export default __exports__